export const staircaseConfig = {
    gameSlug: 'trail-making-a',
    category: 'feu_vivacite',
    variable: 'n_items',
    startValue: 10,
    minValue: 5,
    maxValue: 25,
    stepSizesByPhase: [3, 2, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 20,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, nTargets: 5, gridDensity: 'sparse', label: 'Decouverte' };
    }
    if (level <= 20) {
        return { level, nTargets: 10, gridDensity: 'sparse', label: 'Echauffement' };
    }
    if (level <= 30) {
        return { level, nTargets: 15, gridDensity: 'medium', label: 'Rythme' };
    }
    if (level <= 40) {
        return { level, nTargets: 20, gridDensity: 'medium', label: 'Tempo' };
    }
    return { level, nTargets: 25, gridDensity: 'dense', label: 'Saturation' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** Durees non-staircase (fixation, feedback visuel, ITI). */
export const timing = {
    fixationMs: 400,
    feedbackMs: 700,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'trail-making-a',
    paradigm: 'Trail Making Test Part A (Reitan 1958)',
    category: 'feu_vivacite',
    goal: 'Vitesse visuomotrice : balayage visuel et sequencement.',
};
//# sourceMappingURL=params.js.map